jQuery(document).ready(function($) {



	/* --------------- check of alles goed staat in de header --- */
	doHeaderbeweging();

	/* --- scroll window event --- */
	jQuery(window).scroll(function (event) {
		doHeaderbeweging();
	});

	/* --------- slide header beeld --- */
	function doHeaderbeweging () {
		scrollpositie = jQuery(window).scrollTop();
		if ( scrollpositie > 50 ) {
			jQuery("#navigatie-desktop").addClass('in');
			jQuery("#jaarverslag").addClass('in');
			jQuery("#logo").addClass('in');
			jQuery("#subnavigatie").addClass('in');
		} else {
			jQuery("#navigatie-desktop").removeClass('in');
			jQuery("#jaarverslag").removeClass('in');
			jQuery("#logo").removeClass('in');
			jQuery("#subnavigatie").removeClass('in');
		}
	}



	/* --- resize window event --- */
	jQuery(window).resize(function() {
		checkSizes();
	});

	/* ---------- checked a.h.v. window size of div aan/uit moeten --- */
	function checkSizes() {
		if ( jQuery(document).width() > 1024) {
			jQuery("#navigatie-desktop").removeClass('in');
		}
	}

	/* --------- open/close desktop menu --- */
	jQuery("#togglehoofdmenu").on("click",function(e){
		e.preventDefault();
		jQuery('html, body').animate({
				scrollTop: jQuery("#illustratie").offset().top + 130
		}, 500);
	})

	/* --------- open/close mobile menu --- */
	jQuery("#hamburger").on("click",function(e){
		e.preventDefault();
		jQuery('#navigatie-mobiel').slideToggle(300);
		jQuery("header").toggleClass('zindex');
		jQuery("#hamburger").toggleClass("toggled");
	})

	/* --------- open/close zoekformulier --- */
	jQuery(".openzoek").on("click",function(e){
		e.preventDefault();
		jQuery('#zoekformulier').toggle(300);
	})

	/* --------- open/close zoekformulier --- */
	jQuery("#menubutton").on("click",function(e){
		e.preventDefault();
		jQuery('#downloadmenu').slideToggle(300);
	})

	/* --------- open/close pdf selectie --- */
	var pagePos = 0;
	jQuery(".selectie-maken, #download-selectie .sluiten, #download-selectie-achtergrond").on("click",function(e){
		e.preventDefault();
		if ( jQuery('#download-selectie-wrapper').hasClass('in') ) {
			jQuery('html, body').animate({scrollTop: pagePos + 'px'}, 100); //restore saved window position
		} else {
			pagePos = jQuery(window).scrollTop();  // current y position on the page
		}
		jQuery('#download-selectie-achtergrond').toggleClass('in');
		jQuery('#download-selectie').toggleClass('in');
/*		jQuery('#wrapper').toggleClass('in'); */
	})

	/* --------- desktop navigatie uitklappen --- */
	 jQuery("#navigatie-desktop ul li a.parent, #navigatie-mobiel > ul li a.parent").on("click",function(e) {
			 e.preventDefault();
			 jQuery( this ).toggleClass('actief');
			 if ( jQuery( this ).hasClass('actief')) {
					 jQuery( this ).next('ul').slideDown(300);
			 } else {
					 jQuery( this ).next('ul').slideUp(300);
			 }
	 })

	 /* --------- on load of page; expand menu --- */
	 jQuery("#navigatie-desktop ul li a.actief").next('ul').slideDown(300);
});
